import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from 'rsuite';

import { Edit } from '@rsuite/icons';
import InfoRound from '@rsuite/icons/InfoRound';
import TrashIcon from '@rsuite/icons/Trash';

export default function ActionCell({
  rowData,
  onDetails,
  onEdit,
  onDelete,
}) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '6px'
      }}
    >
      <IconButton
        appearance="subtle"
        title="Detalhes"
        onClick={() => onDetails(rowData)}
        icon={<InfoRound />}
      />

      <IconButton
        appearance="subtle"
        title="Editar"
        onClick={() => onEdit(rowData)}
        icon={<Edit />}
      />
      {onDelete && (
        <IconButton
          appearance="subtle"
          color="red"
          title="Excluir"
          onClick={() => onDelete(rowData)}
          icon={<TrashIcon />}
        />
      )}
    </div>
  );
}

ActionCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
  onDetails: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};